









































































































































































































































































interface ClerkData {
  id: number;
  code: string;
  name: string;
  ware_count: number;
  total_stock: number;
  member_count: number;
  is_merchant: any;
  level: string;
}
interface Form {
  type: number[];
  name: string;
  stock_pattern: string;
}
interface Stock {
  stock_number: string;
}
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { WARE_TYPE_LIST, STOCK_PATTERN } from '../ware/constant';
const { VUE_APP_API } = process.env;
const API = {
  query: `${VUE_APP_API}/qy/ware/clerk-ware-config-list`,
  get_clerk_message: `${VUE_APP_API}/qy/user/clerk/detail`,
  add_stock_url: `${VUE_APP_API}/qy/user/clerk/add-ware-stock`,
  reduce_stock_url: `${VUE_APP_API}/qy/user/clerk/reduce-ware-stock`,
  init_stock: `${VUE_APP_API}/qy/user/clerk/init-stock`,
  edit_ware: `${VUE_APP_API}/qy/user/clerk/edit-ware-relevance`,
  relevance_ware: `${VUE_APP_API}/qy/user/clerk/relevance-ware`,
};

const MARK_STATUS_LIST = {
  1: '上架中',
  2: '已售罄',
  3: '仓库中',
};
@Component
export default class StockManage extends Vue {
  is_loading: boolean = false;
  clerk_data: ClerkData[] = [];
  ware_type_list: any = WARE_TYPE_LIST;
  stock_pattern_list: any = STOCK_PATTERN;
  mark_status_list: any = MARK_STATUS_LIST;
  stock_status_list: any = {};
  clerk_id: string = '';
  level: string = '';
  is_merchant: any = '';
  form: Form = {
    type: [0],
    name: '',
    stock_pattern: '0',
  };
  is_show_ware_modal: boolean = false;
  is_show_edit_stock_modal: boolean = false;
  page: number = 1;
  table_data: RemotePagination<any> = {
    current_page: 1,
    last_page: 1,
    per_page: 1,
    total: 0,
    data: [],
  };
  table_popup_add: any = {};
  table_popup_reduce: any = {};
  add_stock: any = '';
  record_stock: any = '';
  ware_item: any = {};
  white_ware_id: any = [];
  black_ware_id: any = [];
  relevance_ware: any = [];
  ware_modal: Form = {
    type: [0],
    name: '',
    stock_pattern: '0',
  };
  stock_modal: Stock = {
    stock_number: '',
  };
  ware_page: number = 1;
  ware_data: any = {};
  ware_id_list: any = [];
  table_loading: boolean = false;
  stock_modal_layout: any = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  stock_item: any = {};

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  handChangeWarePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.submitWare(next_page);
  }

  paginationOption(data: RemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.per_page}条`,
      pageSize: data.per_page || 1,
      current: data.current_page || 1,
    };
  }

  isShowStockPopupAdd(popup: any, item: any) {
    return popup.ware_id === item.ware_id;
  }

  isShowStockPopupReduce(popup: any, item: any) {
    return popup.ware_id === item.ware_id;
  }

  handleTablePopupCancel() {
    this.table_popup_add = {};
    this.table_popup_reduce = {};
  }

  showStockPopup(item: any, type: any) {
    if (type === 'add') {
      this.table_popup_add = item;
      this.table_popup_reduce = {};
    } else if (type === 'reduce') {
      this.table_popup_reduce = item;
      this.table_popup_add = {};
    }
  }

  async editStock(item: any, type: any, edit_type: any) {
    // type 表示编辑分销商品，edit_type表示增加还是减少
    if (edit_type === 'add') {
      if (!this.add_stock) {
        this.$message.error('请输入增加库存数');
        return;
      }
      if (!/(^[1-9]+\d*$)|(^0$)/.test(this.add_stock.toString())) {
        this.$message.error('库存数需为整数值');
        return;
      }
    } else {
      if (!this.record_stock) {
        this.$message.error('请输入减少库存数');
        return;
      }
      if (!/(^[1-9]+\d*$)|(^0$)/.test(this.record_stock.toString())) {
        this.$message.error('库存数需为整数值');
        return;
      }
    }
    const url = edit_type === 'add' ? API.add_stock_url : API.reduce_stock_url;
    const send_data: any = {};
    send_data.clerk_id = this.clerk_id;
    send_data.ware_id = item.ware_id;
    send_data.stock = edit_type === 'add' ? this.add_stock : this.record_stock;
    const _data = ((await this.$axios.post(url, send_data)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.table_popup_add = {};
    this.table_popup_reduce = {};
    this.add_stock = '';
    this.record_stock = '';
    this.ware_item.total_stock =
      edit_type === 'add'
        ? this.ware_item.total_stock + Number(send_data.stock)
        : this.ware_item.total_stock - Number(send_data.stock);
    this.query(this.page);
  }

  cancelEdit() {
    this.white_ware_id = [];
    this.black_ware_id = [];
    const ware_modal = this.ware_modal;
    ware_modal.type = [0];
    ware_modal.name = '';
    ware_modal.stock_pattern = '0';
    this.ware_data.data = [];
    this.ware_page = 1;
  }

  async editWare() {
    const send_data: any = {};
    send_data.code = this.clerk_data[0].code;
    send_data.white_ware_id = this.white_ware_id;
    send_data.black_ware_id = this.black_ware_id;
    const res = await this.$axios.post(API.edit_ware, send_data);
    const remote = res.data;
    if (remote.error) {
      this.$message.error(remote.message);
    } else {
      this.$message.success('编辑成功');
    }
    this.is_show_ware_modal = false;
    await this.query(this.page);
    await this.getClerkMessage();
    this.cancelEdit();
    this.ware_page = 1;
  }

  onSelectChange(selectedRowKeys: any) {
    this.white_ware_id = Array.from(new Set(selectedRowKeys));
    this.black_ware_id = [];
    const ware_id_list = new Set(this.ware_id_list);
    const selected = new Set(this.white_ware_id);
    for (const set of ware_id_list) {
      if (!selected.has(set)) {
        this.black_ware_id.push(set);
      }
    }
  }

  getCheckboxProps(record: any) {
    return {
      props: {
        disabled: this.is_merchant === 1,
        name: record.name,
      },
    };
  }

  searchWare() {
    this.submitWare(this.ware_page);
  }

  async submitWare(page: number = 1) {
    this.table_loading = true;
    this.ware_page = page;
    const ware_modal = this.ware_modal;
    const send_data: any = {
      page: this.ware_page,
      clerk_id: this.clerk_id,
      type: ware_modal.type[0],
      name: ware_modal.name,
      stock_pattern: ware_modal.stock_pattern === '0' ? [] : [ware_modal.stock_pattern],
      clerk_usable: 0,
    };
    if (ware_modal.type[1]) {
      send_data.type_secondary = ware_modal.type[1] ? ware_modal.type[1] : '0';
    }
    const res = await this.$axios.get(API.query, {
      params: send_data,
    });
    const remote = res.data;
    if (remote.error) {
      this.$message.error(remote.message);
      this.table_loading = false;
      return;
    }
    this.ware_data = remote.data;
    const wareList: any = [];
    this.ware_id_list = [];
    this.ware_data.data.forEach((item: any) => {
      // relevance_ware为已经绑定的商品，此处拆分出商品列表中已绑定和未绑定的商品
      this.ware_id_list.push(item.ware_id);
      wareList.push(item.ware_id);
    });
    this.black_ware_id = [];
    const ware_id_list = new Set(this.ware_id_list);
    const relevance_ware = new Set(this.relevance_ware);
    for (const set of ware_id_list) {
      if (!relevance_ware.has(set)) {
        this.white_ware_id.push(set);
      }
    }
    this.black_ware_id = this.relevance_ware;
    this.table_loading = false;
  }

  async changeWare() {
    this.is_show_ware_modal = true;
    const res = await this.$axios.post(API.relevance_ware, {
      code: this.clerk_data[0].code,
    });
    const remote = res.data;
    if (remote.error) {
      this.$message.error(remote.message);
      return;
    }
    this.relevance_ware = remote.data.relevance_ware; // 黑名单
    this.submitWare(this.ware_page);
  }

  showStockModal(item: any) {
    this.stock_item = item;
    this.is_show_edit_stock_modal = true;
  }

  cancelStock() {
    this.is_show_edit_stock_modal = false;
    this.stock_modal.stock_number = '';
  }

  async submitEditStock() {
    if (!this.stock_modal.stock_number) {
      this.$message.error('请输入每位二级增加库存数');
      return;
    }
    if (Number(this.stock_modal.stock_number) <= 0) {
      this.$message.error('输入的库存量必须大于零');
      return;
    }
    const send_data: any = {
      clerk_id: this.clerk_id,
      ware_id: this.stock_item.ware_id,
      stock: this.stock_modal.stock_number,
    };
    const res = await this.$axios.post(`${API.init_stock}`, send_data);
    if (res.data.error) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success(res.data.message);
    this.is_show_edit_stock_modal = false;
    this.stock_modal.stock_number = '';
    this.query(this.page);
  }

  async getClerkMessage() {
    const res = await this.$axios.get(
      `${API.get_clerk_message}?id=${this.clerk_id}`,
    );
    if (res.data.error) {
      return;
    }
    const data = res.data.data || {};
    this.clerk_data = [data];
    this.level = this.clerk_data[0].level;
    this.is_merchant = this.clerk_data[0].is_merchant;
  }

  wareTag(item: any) {
    const text_first: string = item.type === 1 ? '实物' : '虚拟';
    const text_second: string =
      item.type === 1
        ? ''
        : item.type === 2 && item.type_secondary === 1
        ? '/兑换码'
        : '/无';
    return `${text_first}${text_second}`;
  }

  clearForm() {
    const form = this.form;
    form.type = [0];
    form.name = '';
    form.stock_pattern = '0';
  }

  submit() {
    this.query(1);
  }

  async query(page: number = 1) {
    this.page = page;
    const form = this.form;
    const send_data: any = {
      page,
      clerk_id: this.clerk_id,
      type: form.type[0],
      name: form.name,
      stock_pattern: form.stock_pattern === '0' ? [] : [form.stock_pattern],
      clerk_usable: 1,
    };
    if (form.type[1]) {
      send_data.type_secondary = form.type[1] ? form.type[1] : '0';
    }
    const res = await this.$axios.get(API.query, { params: send_data });
    if (res.data.error) {
      return;
    }
    const data = res.data.data || {};
    this.table_data = data;
    this.table_data.data.forEach((item: any) => {
      item.is_edit = item.stock_pattern !== '3' && (this.level === '1' || (this.level === '2' && item.stock_pattern === '2'));
    });
  }

  async created() {
    this.is_loading = true;
    this.clerk_id = this.$route.query.id as string;
    await this.getClerkMessage();
    await this.query(1);
    this.stock_pattern_list.forEach((item: any) => {
      this.stock_status_list[item.value] = item.label;
    });
    this.is_loading = false;
  }
}
